import { ApplicationConfig } from '@angular/core';
import { mpsConfig } from './mps/mps.config';
import { applicationConfig } from './app/application.config';

export const globalConfig: ApplicationConfig = {
  providers: [...mpsConfig.providers, ...applicationConfig.providers],
};
